import React, { type ReactNode } from 'react'

export const SendIcon = (props: React.ComponentPropsWithoutRef<'svg'>): ReactNode => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="14px" {...props}>
    <path
      fill="currentColor"
      d="M511.1 255.1c0 12.8-7.625 24.38-19.41 29.41L44.6 477.4c-4.062 1.75-8.344 2.594-12.59 2.594c-8.625 0-17.09-3.5-23.28-10.05c-9.219-9.766-11.34-24.25-5.344-36.27l73.66-147.3l242.1-30.37L77.03 225.6l-73.66-147.3C-2.623 66.3-.4982 51.81 8.72 42.05c9.25-9.766 23.56-12.75 35.87-7.453L492.6 226.6C504.4 231.6 511.1 243.2 511.1 255.1z"
    />
  </svg>
)
